import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeaker20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSpeaker20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.658 8.342h.585l.43-.395 2.363-2.17v8.533l-2.363-2.17-.43-.396H3.5V8.342zM2 8.342a1.5 1.5 0 0 1 1.5-1.5h2.158l3.201-2.94c.641-.59 1.677-.135 1.677.736v10.81c0 .87-1.036 1.326-1.677.737l-3.2-2.941H3.5a1.5 1.5 0 0 1-1.5-1.5zm11.539-3.58a.75.75 0 0 1 .948-.473L14.25 5l.238-.711h.003l.005.003.014.004a2 2 0 0 1 .165.066 5 5 0 0 1 .408.201c.33.183.764.473 1.197.907C17.163 6.35 18 7.788 18 10c0 2.206-.815 3.641-1.676 4.524a5.3 5.3 0 0 1-1.172.91 4.4 4.4 0 0 1-.545.261l-.019.007-.013.005-.005.002h-.003L14.323 15l.243.71a.75.75 0 0 1-.49-1.418l.01-.003.062-.026c.058-.026.15-.07.261-.133a3.8 3.8 0 0 0 .84-.654C15.853 12.86 16.5 11.794 16.5 10c0-1.788-.661-2.85-1.28-3.47a4 4 0 0 0-.865-.656 3 3 0 0 0-.336-.16l-.01-.004a.75.75 0 0 1-.47-.947m-1.013 2.822a.75.75 0 0 1 1.04-.208L13.15 8l.417-.624.002.002.002.002.007.004.018.013.052.038q.061.046.157.13c.123.11.285.271.445.485.323.43.65 1.084.65 1.95s-.327 1.52-.65 1.95a3.3 3.3 0 0 1-.602.615l-.052.039-.018.012-.007.005-.002.002h-.002L13.15 12l.416.624a.75.75 0 0 1-.839-1.243l.011-.009q.022-.016.07-.057c.064-.057.153-.146.242-.265.177-.236.35-.582.35-1.05 0-.467-.173-.813-.35-1.05a1.8 1.8 0 0 0-.312-.322l-.01-.008a.75.75 0 0 1-.202-1.036"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeaker20);
